/**
 * Auth Service
 * All authentication-related API calls
 */

import { apiClient } from '../client';
import type { User, LoginResponse, RegisterPayload, UpdateProfilePayload } from '../../../entities/user';

export const authService = {
    /** Register a new user */
    register: (data: RegisterPayload) =>
        apiClient.post<User>('/auth/register', data),

    /** Login with email + password (form-data) */
    login: (email: string, password: string) => {
        const formData = new FormData();
        formData.append('username', email);
        formData.append('password', password);
        return apiClient.post<LoginResponse>('/auth/login', formData, { raw: true });
    },

    /** Refresh access token */
    refreshToken: (refreshToken: string) =>
        apiClient.post<LoginResponse>(
            `/auth/refresh?refresh_token=${encodeURIComponent(refreshToken)}`,
        ),

    /** Get current authenticated user */
    getCurrentUser: () =>
        apiClient.get<User>('/auth/me'),

    /** Update user profile */
    updateProfile: (data: UpdateProfilePayload) =>
        apiClient.patch<User>('/auth/me', data),

    /** Simulate Pro Subscription Upgrade */
    upgradeToPro: () =>
        apiClient.post<User>('/auth/me/upgrade'),

    /** Get user by ID (admin) */
    getUserById: (userId: string) =>
        apiClient.get<User>(`/auth/users/${userId}`),
};
